export default "__VITE_PUBLIC_ASSET__4face2b9__"